var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgH1 = function SvgH1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "currentColor",
    style: {
      color: "#6a89a6"
    }
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#6A89A6",
    strokeWidth: 0.094,
    d: "M24.39 14.75v7.5a.89.89 0 0 1-1.78 0v-5.836l-.074.049-.417.28a.89.89 0 0 1-1.369-.57.892.892 0 0 1 .38-.915l1.876-1.25a.891.891 0 0 1 1.385.742Zm.047 0v7.5a.938.938 0 0 1-1.875 0v-5.692l.027-.017-.026-.04h-.047l1.922-1.751Zm-8.125-.578h.047v-3.797a.89.89 0 1 1 1.782 0v9.375a.89.89 0 0 1-1.782 0v-3.797h-6.343v3.797a.89.89 0 0 1-1.782 0v-9.375a.89.89 0 0 1 1.782 0v3.797h6.296Z"
  })));
};
export default SvgH1;